import React from "react";
import "./Why_Choose_Us.css";

const Why_Choose_Us = ({ text1, text2 }) => {
  return (
    <section className="Why_Choose_Us">
      <div className="container">
        <div className="main_div_holder">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4 col-12">
              <div className="left_side_card">
                <div className="img_holder">
                  <img
                    src="/Assets/Images/Service/Services/digital_media/why_choose/question.png"
                    className="question_img"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-lg-8 col-sm-8 col-12">
              <div className="right_side_card">
                <div className="tile_div">
                  <p className="title">Why Choose Us?</p>
                </div>

                <div className="desc_div">
                  <div className="heading_holder">
                    <p className="heading">At ReachOut Media Tech Pvt. Ltd.,</p>
                  </div>
                  <div className="text_div">
                    <p className="text">{text1}</p>

                    <br />
                    {/* <p className="text">
                      <b>CTA: </b> <br />
                      {text2}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Choose_Us;
